import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-left"
}
const _hoisted_2 = {
  key: 0,
  class: "mt40"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", {
  class: "header_title fs18 fl",
  style: {}
}, "スグINボタン設定", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "dgrey fs13 mb10" }, [
  /*#__PURE__*/_createTextVNode(" この公開ページは「スグINボタン」として機能します。スグINボタンは公開ページに設置、もしくは、ボタン単体で利用ができます。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 設定している調整カレンダーの担当者グループごとに担当者を割り当ててください。 ")
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", {
  for: `is_instant_room_`,
  class: "fs13"
}, "この公開ページを「スグINボタン」として利用する", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_10 = {
  key: 1,
  class: "mt40"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", {
  class: "header_title fs18 fl",
  style: {}
}, "スグINボタンを紐付ける", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "dgrey fs13 mb10" }, " 「スグINボタン」として利用する公開ページを紐付けます。事前にスグINボタンにする公開ページの設定でスグINボタン専用に変更してください。 ", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", {
  for: `use_instant_room_`,
  class: "fs13"
}, "「スグINボタン」を紐付ける", -1)
const _hoisted_16 = {
  class: "mt10",
  style: {"width":"320px"}
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_18 = {
  key: 0,
  class: "fs11 fw600"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CheckboxTag = _resolveComponent("CheckboxTag")!
  const _component_MdTextfieldTag = _resolveComponent("MdTextfieldTag")!

  return (_ctx.rcm && _ctx.rcm.room)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.canUseInstantRoom)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("img", {
                src: _ctx.$getAssetImageUrl(`/assets/icons/operator.png`),
                width: "26",
                height: "26",
                class: "pointer fl mr10",
                style: {"margin-top":"-4px"}
              }, null, 8, _hoisted_3),
              _hoisted_4,
              _hoisted_5,
              _hoisted_6,
              _hoisted_7,
              _createVNode(_component_CheckboxTag, {
                value: ``,
                name: `is_instant_room`,
                checked: _ctx.rcm.room_setting.is_instant_room,
                prefix: `is_instant_room`,
                onClickCheckbox: _ctx.clickIsInstantRoom,
                style: {"margin-left":"1px","margin-right":"7px"}
              }, null, 8, ["checked", "onClickCheckbox"]),
              _hoisted_8,
              _hoisted_9
            ]))
          : _createCommentVNode("", true),
        (_ctx.canUseInstantRoom && !_ctx.rcm.room_setting.is_instant_room)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _hoisted_11,
              _hoisted_12,
              _hoisted_13,
              _hoisted_14,
              _createVNode(_component_CheckboxTag, {
                value: ``,
                name: `use_instant_room`,
                checked: _ctx.rcm.room_setting.use_instant_room,
                prefix: `use_instant_room`,
                onClickCheckbox: _ctx.clickUseInstantRoom,
                style: {"margin-left":"1px","margin-right":"7px"}
              }, null, 8, ["checked", "onClickCheckbox"]),
              _hoisted_15,
              _createElementVNode("div", _hoisted_16, [
                _createVNode(_component_MdTextfieldTag, {
                  name: "公開ページIDを入力",
                  fieldStyle: "min-width:250px;max-width:250px;",
                  style: {"height":"56px","min-width":"250px"},
                  class: "fs16 fl",
                  value: _ctx.publicId,
                  onInputValue: _ctx.inputPublicID,
                  required: ""
                }, null, 8, ["value", "onInputValue"]),
                _createElementVNode("div", {
                  class: "fl greyBg rad5 mt16 fs11 pointer hoverGreyBg",
                  style: {"padding":"13px","height":"40px"},
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clickConnectInstantPage && _ctx.clickConnectInstantPage(...args)))
                }, " 紐付け "),
                _hoisted_17,
                (_ctx.selectedRoom)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, " 「" + _toDisplayString(`[${_ctx.selectedRoom.public_id}]${
                            _ctx.selectedRoom.appeal_content.title
                                ? _ctx.selectedRoom.appeal_content.title
                                : _ctx.selectedRoom.current_appointment.name
                        }`) + "」の「スグINボタン」専用ページを紐付けています。 ", 1))
                  : _createCommentVNode("", true),
                _hoisted_19
              ]),
              _hoisted_20
            ]))
          : _createCommentVNode("", true),
        _hoisted_21
      ]))
    : _createCommentVNode("", true)
}